import React from "react"

/* Import Local Styles */
import "./submit.css"

const Submit = ({ disabled, children, style = {} }) => {
  return (
    <div style={style}>
      <button className="submit" type="submit" disabled={disabled}>
        {children}
      </button>
    </div>
  )
}

export default Submit
